import * as React from 'react';
import { classes, style, stylesheet } from 'typestyle';
import { Blood, Blue, Cream, Gold } from '../../../styles/colors';
// Atoms
import Label from '../../atoms/Label';
import Input from '../../atoms/Input';
import { smallStyle } from '../../..';
import { borderPx, errMsgStyle, inputContainerStyle, titleStyle, warnMsgStyle } from '../../../styles/input';
class TextInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focused: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(value) {
        this.props.onChange(value);
    }
    render() {
        const { name, value, title, placeholder, errorMessage, className, isInvalid = false, disabled = false, onBlur, onFocus, leftIcon, rightIcon, isWarning = false, warningMessage, type, autoFocus, tabIndex, } = this.props;
        const { focused } = this.state;
        const showPlaceholder = !focused && !value;
        const hasLeftIcon = !!leftIcon;
        const hasRightIcon = !!rightIcon;
        return (React.createElement("div", { className: classes('ta-text-input', inputContainerStyle, textInputContainerStyle) },
            title && !showPlaceholder && (React.createElement(Label, { title: title, className: classes(titleStyle.common, smallStyle, focused && !isInvalid && !isWarning && titleStyle.focused, isInvalid && titleStyle.error, isWarning && titleStyle.warning, hasLeftIcon && leftIconTitleStyle) })),
            hasLeftIcon && React.createElement("div", { className: leftIconStyle }, leftIcon),
            React.createElement(Input, { autoFocus: autoFocus, name: name, className: classes(className, textInputStyle.common, !title && textInputStyle.noTitle, title && !showPlaceholder && textInputStyle.showTitle, isInvalid && textInputStyle.error, isWarning && textInputStyle.warning, hasLeftIcon && textInputStyle.hasLeftIcon, hasRightIcon && textInputStyle.hasRightIcon, focused && textInputStyle.focused), disabled: disabled, placeholder: showPlaceholder ? placeholder : '', onChange: this.handleChange, onFocus: () => {
                    this.setState({ focused: true });
                    onFocus && onFocus();
                }, onBlur: () => {
                    this.setState({ focused: false });
                    onBlur && onBlur();
                }, value: value, type: type, tabIndex: tabIndex }),
            hasRightIcon && React.createElement("div", { className: rightIconStyle }, rightIcon),
            errorMessage && isInvalid && React.createElement(Label, { title: errorMessage, className: classes(errMsgStyle, smallStyle) }),
            warningMessage && isWarning && React.createElement(Label, { title: warningMessage, className: classes(warnMsgStyle, smallStyle) })));
    }
}
export default TextInput;
const textInputContainerStyle = style({
    minHeight: 40,
});
export const textInputStyle = stylesheet({
    common: {
        caretColor: Blue,
        '-webkit-appearance': 'none', // hack for ios/safari
    },
    noTitle: {
        padding: '12px !important',
    },
    showTitle: {
        paddingTop: '20px !important',
        paddingBottom: '4px !important',
    },
    error: {
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${Blood} !important`,
        color: `${Blood} !important`,
        $nest: {
            '&::placeholder': {
                color: `${Blood} !important`,
            },
        },
    },
    hasLeftIcon: {
        paddingLeft: '44px !important',
    },
    hasRightIcon: {
        paddingRight: '44px !important',
    },
    focused: {
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${Blue}`,
    },
    warning: {
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${Gold}`,
        color: `${Gold} !important`,
        backgroundColor: `${Cream} !important`,
        $nest: {
            '&::placeholder': {
                color: `${Gold} !important`,
            },
        },
    },
});
const leftIconTitleStyle = style({
    left: '44px !important',
});
const leftIconStyle = style({
    position: 'absolute',
    top: 8,
    left: 12,
});
const rightIconStyle = style({
    position: 'absolute',
    top: 8,
    right: 12,
});
//# sourceMappingURL=TextInput.js.map